module.exports = __webpack_public_path__ + "img/address_kc.784807d2.png";